import {useAuthAxios} from 'hooks/api/useAuthAxios'

export const usePost = () => {
  const authAxios = useAuthAxios()
  return async (egovProcedureId: string, pinCode: string) => {
    const path = `/api/egov_procedure_statuses/${egovProcedureId}/apply`
    return authAxios.post(path, {pin: pinCode})
  }
}
